import { Action } from '@ngrx/store';
import * as Actions from './grant-state-to-children.actions';
import { IGrantStateToChildrenState } from './grant-state-to-children.model';

export const grantStateToChildren: IGrantStateToChildrenState = {
  isGetChildrenOfSelectedLogbookLoading: false,
  isGetChildrenOfSelectedLogbookLoaded: false,
  isGrantStateToChildrenOfSelectedLogbookLoading: false,
  isGrantStateToChildrenOfSelectedLogbookLoaded: false,
};

export function grantStateToChildrenReducer(
  state: IGrantStateToChildrenState = grantStateToChildren,
  baseAction: Action,
): IGrantStateToChildrenState {
  const action: Actions.GrantStateToChildrenActions = baseAction as Actions.GrantStateToChildrenActions;
  switch (action.type) {
    case Actions.GET_CHILDREN_OF_SELECTED_LOGBOOK:
      return {
        ...state,
        isGetChildrenOfSelectedLogbookLoading: true,
        isGetChildrenOfSelectedLogbookLoaded: false,
      };
    case Actions.GET_CHILDREN_OF_SELECTED_LOGBOOK_COMPLETED:
      return {
        ...state,
        isGetChildrenOfSelectedLogbookLoading: false,
        isGetChildrenOfSelectedLogbookLoaded: true,
      };
    case Actions.GRANT_STATE_TO_CHILDREN_OF_SELECTED_LOGBOOK:
      return {
        ...state,
        isGrantStateToChildrenOfSelectedLogbookLoading: true,
        isGrantStateToChildrenOfSelectedLogbookLoaded: false,
      };
    case Actions.GRANT_STATE_TO_CHILDREN_OF_SELECTED_LOGBOOK_COMPLETED:
      return {
        ...state,
        isGrantStateToChildrenOfSelectedLogbookLoading: false,
        isGrantStateToChildrenOfSelectedLogbookLoaded: true,
      };
    default:
      return state;
  }
}
